var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 100,
    viewBox: "0 0 152 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.12 70.713H144.908C148.266 70.713 150.998 72.9985 150.998 75.9367C150.998 77.308 150.295 78.614 149.202 79.5281C148.109 80.4422 146.626 81.03 144.908 81.03H134.681C133.432 81.03 132.261 81.487 131.48 82.14C130.621 82.793 130.153 83.7071 130.153 84.7518C130.153 86.7761 132.105 88.4737 134.603 88.4737H137.023C140.38 88.4737 143.113 90.7592 143.113 93.5668C143.113 94.938 142.41 96.244 141.317 97.1583C140.224 98.0724 138.741 98.66 137.023 98.66H55.8288C52.4716 98.66 49.7392 96.3745 49.7392 93.5668C49.7392 92.1957 50.4419 90.8897 51.5348 89.9756C52.6279 89.0613 54.1112 88.4737 55.8288 88.4737H69.0801C71.1613 88.4737 72.8484 86.7927 72.8484 84.7191C72.8484 80.2913 71.1613 79.1362 69.0801 79.1362H63.636H53.7903H23.8974C19.9938 79.1362 16.793 76.4591 16.793 73.1944C16.793 71.5619 17.5737 70.06 18.9009 69.0154C20.1501 67.9053 21.9457 67.2524 23.8974 67.2524H33.5783C35.5302 67.2524 37.3258 66.5994 38.653 65.4893C39.9803 64.4445 40.761 62.8774 40.761 61.2451C40.761 57.9149 37.5599 55.2377 33.5783 55.2377H26.6299C23.8194 55.2377 21.5554 53.3442 21.5554 50.9935C21.5554 49.8181 22.1018 48.7735 23.0386 47.9899C23.9755 47.2062 25.2247 46.7491 26.6299 46.7491H35.2179L91.681 46.6186H92.2101C95.0206 46.6186 97.2847 47.7995 97.2847 50.863C97.2847 51.8003 97.1877 52.9523 100.013 52.9523H134.837C137.804 52.9523 140.146 54.9766 140.146 57.3926C140.146 58.6332 139.522 59.7432 138.584 60.5268C137.648 61.3103 136.32 61.8328 134.837 61.8328H133.12C131.636 61.8328 130.309 62.3552 129.372 63.1387C128.435 63.9223 127.811 65.0323 127.811 66.2729C127.811 68.7541 130.231 70.713 133.12 70.713Z",
    fill: "white",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2096 88.6615C101.061 88.6615 115.533 74.19 115.533 56.3386C115.533 38.4871 101.061 24.0157 83.2096 24.0157C65.3582 24.0157 50.8867 38.4871 50.8867 56.3386C50.8867 74.19 65.3582 88.6615 83.2096 88.6615Z",
    fill: "#79F3BD",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3295 47.6348L80.3296 47.6349L92.73 54.794C92.73 54.7941 92.7301 54.7941 92.7301 54.7941C94.2394 55.6658 94.2394 57.8441 92.73 58.7158L80.3296 65.875C80.3296 65.875 80.3296 65.875 80.3296 65.875C78.8201 66.7463 76.9336 65.6571 76.9336 63.9144V49.5955C76.9336 47.8525 78.8203 46.7633 80.3295 47.6348Z",
    fill: "white",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.375,
    cy: 32.4917,
    r: 3.48805,
    fill: "#D9D9D9",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 35C37.0147 35 35 32.9853 35 30.5C35 28.0147 37.0147 26 39.5 26C41.9853 26 44 28.0147 44 30.5C44 32.9853 41.9853 35 39.5 35Z",
    fill: "#79F3BD",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4659 97.2476C35.2824 96.4929 36.9538 93.598 36.1991 90.7815C35.4444 87.9651 32.5495 86.2937 29.733 87.0483C26.9166 87.803 25.2452 90.6979 25.9998 93.5144C26.7545 96.3308 29.6495 98.0022 32.4659 97.2476Z",
    fill: "#E1E4E5",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0713 7.88747C47.0713 11.8084 50.3526 15.0249 54.4477 15.0249C58.5429 15.0249 61.8242 11.8084 61.8242 7.88747C61.8242 3.9665 58.5429 0.75 54.4477 0.75C50.3526 0.75 47.0713 3.9665 47.0713 7.88747Z",
    fill: "#E1E4E5",
    stroke: "#646E79",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86037 28H8.97546C9.65712 37.6665 16.8383 37.8156 16.8383 37.8156C16.8383 37.8156 8.91912 37.9702 8.91912 49.14C8.91912 37.9702 1 37.8156 1 37.8156C1 37.8156 8.17872 37.6665 8.86037 28Z",
    fill: "#E1E4E5",
    stroke: "#646E79",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideos);
export default __webpack_public_path__ + "static/media/noVideos.08319813f0815ef5cc16338a53aece56.svg";
export { ForwardRef as ReactComponent };